import React from 'react';
import PropTypes from 'prop-types';

import {
  getStorage,
  updateStorage
} from '../../../utils/storage';

import Loading from '../../../components/loading';

import SelectOrUpload from './select-or-upload';
import ReferenceEdit from './reference-edit';
import Navigator from '../../../components/navigator';

import loadExcel from '../../../components/workbook/load';
import RawDataCollection from '../../../models/raw-data-collection';
import GTable from '../../../components/gsheet/gtable';


export default class ReferenceSelection extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      rawDataCollection: null,
      pageStatus: {
        hideEditor: true,
        loading: false,
      }
    };
  }

  async componentDidMount() {
    const {location: {query}} = this.props;
    if (query && 'load' in query) {
      const {rawDataCollection} = await getStorage(query.load);
      this.setState({
        rawDataCollection,
      });
      if (rawDataCollection.reference) {
        this.setPageStatus({hideEditor: false});
      }
    } else {
      const rawDataCollection = new RawDataCollection();
      this.setState({
        rawDataCollection,
      });
      this.setPageStatus({hideEditor : true});
    }
  }

  setPageStatus(newStatus={}) {
    const defaults = {
      loading: false,
      hideEditor: false,
      showError: false,
    };

    const {pageStatus} = this.state;

    Object.assign(pageStatus, defaults, newStatus);
    if (newStatus.hideEditor) {
      pageStatus.loading = false;
    }
    if (newStatus.showError) {
      pageStatus.loading = false;
    }
    this.setState({
      pageStatus,
    });
  }

  get isLoading() {
    const {pageStatus, rawDataCollection} = this.state;
    if (!rawDataCollection) {
      return true;
    }
    return pageStatus.loading;
  }

  handleSelectReference(reference) {
    this.handleUpdateReference(reference);
  }

  handleUpdateReference(newReference) {
    const {rawDataCollection} = this.state;
    rawDataCollection.reference = newReference;
    this.setState({
      rawDataCollection
    });
    this.setPageStatus();
  }

  async handleLoadFile(files) {
    let {rawDataCollection} = this.state;
    const file = files[0];

    rawDataCollection = await loadExcel(file, rawDataCollection);
    rawDataCollection.loadFrom = 'Mangabey file';

    this.setState({
      rawDataCollection,
    });

    this.setPageStatus();
  }

  async handleSubmit() {
    const {rawDataCollection} = this.state;
    if (!rawDataCollection.reference.validate()) {
      this.setPageStatus({showError: true});
      return;
    } else {
      await this.handleNextPage();
    }
  }

  async handleNextPage() {
    const {rawDataCollection} = this.state;
    const pathname = this.props.location.pathname;

    const state = {
      pathname: pathname,
      rawDataCollection
    };
    const load = await updateStorage(state);
    this.context.router.replace({
      pathname: pathname,
      query: {load}
    });

    let target = '/wizard/isolate';
    this.context.router.push({
      pathname: target,
      query: {load}
    });
  }

  get referenceEdit() {
    const {rawDataCollection} = this.state;

    const {pageStatus} = this.state;
    if (pageStatus.hideEditor) {
      return null;
    }

    return (
      <ReferenceEdit
       reference={rawDataCollection.reference}
       showError={pageStatus.showError}
       onUpdate={
         this.handleUpdateReference.bind(this)}
       onSubmit={
         this.handleSubmit.bind(this)}
      />
    );
  }

  render() {
    if (this.isLoading) {
      return <Loading />;
    }

    const {rawDataCollection} = this.state;

    return (
      <div>
        <Navigator
         rawDataCollection={rawDataCollection}
        />
        <SelectOrUpload
         reference={rawDataCollection.reference}
         onSelect={
          this.handleSelectReference.bind(this)}
         onLoadFile={
          this.handleLoadFile.bind(this)}
        />
        <hr/>
        {this.referenceEdit}
        <GTable
         spreadsheet_id={rawDataCollection.spreadsheet_id}
         sheet_id={rawDataCollection.sheet_id}
         ></GTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/index.js